const mResetPassword = {
  mResetPassword: {
    alerts: {
      error: 'Los datos ingresados son incorrectos.'
    },

    buttonPrimary: 'Aceptar',

    formInfo: 'Crear Contraseña',

    inputs: {
      confirm_password: {
        placeholder: 'Confirmar la contraseña'
      },

      password: {
        placeholder: 'Contraseña'
      }
    },

    validation: {
      confirm_password: {
        required: 'Confirmar la contraseña es requerido.',
        sameAsPassword: 'La contraseña no coinciden.'
      },

      password: {
        minLength: 'La longitud mínima permitida es de 8 caracteres.',
        required: 'Contraseña es requerida.',
        valid: 'La contraseña debe contener minúsculas, mayúsculas y números.'
      }
    }
  }
}

export default mResetPassword
